import React from "react";
import Grid from "./Grid";
import { PremiumLoader } from "../../common/Components/Loader";

const Companies = ({ products, error, state }) => {
  if (state === "loading") {
    return (
      <PremiumLoader 
        isLoading={true}
        text="Processing "
        subText="Finding the best deals for you"
        showProgress={true}
        duration={3000}
        size={60}
        color="#3B82F6"
        spinnerType="ring"
        backgroundColor="bg-black/90"
        textColor="text-white"
        progressColor="from-blue-500 to-purple-600"
        showDots={true}
        pulseBackground={true}
      />
    );
  }

  return (
    <div className="companies">
      <div className="grid justify-between grid-cols-1 py-4 gap-7 md:grid-cols-2 lg:grid-cols-3">
        {products?.map((product) => {
          return <Grid key={product.id} product={product} />;
        })}
      </div>
    </div>
  );
};

export default Companies;
